import * as React from "react";
import {createNativeStackNavigator} from "@react-navigation/native-stack";
import ContestDetail from "./childScreen/contestDetail";
import Events from "../event/Events";
import ContestLeaderBoard from "./childScreen/ContestLeaderBoard";
import Portfolio from "../portfolio/Portfolio";
import {useInitialiseSocketConnection} from "../../common/initialiseSocketConnection";
import {useSelector} from "react-redux";
import Tokens from "./childScreen/Tokens";
import ContestsTab from "./childComponents/ContestsTab";

const Stack = createNativeStackNavigator();

export const ContestStack = ({storeData, route}) => {
  const ws = useSelector(({liveReducer}) => liveReducer?.wsRef);
  useInitialiseSocketConnection(
    ws,
    true,
    route?.params?.params?.contestId,
    false,
  );
  return (
    <Stack.Navigator
      screenOptions={({route, navigation}) => ({
        headerShown: false,
        gestureEnabled: true,
      })}>
      <Stack.Screen name="contestDetail" component={ContestDetail} />
      <Stack.Screen
        name="ContestEvents"
        component={Events}
        options={{animation: "none"}}
      />
      <Stack.Screen name="ContestPortfolio" component={Portfolio} />
      <Stack.Screen name="LeaderBoard" component={ContestLeaderBoard} />
      <Stack.Screen name="Tokens" component={Tokens} />
      <Stack.Screen name="contestList" component={ContestsTab} />
    </Stack.Navigator>
  );
};
